import { ChakraProvider, Box } from '@chakra-ui/react';
import { theme } from './theme';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { CompanyInfo } from './components/layout/CompanyInfo';
import { Hero } from './components/landing/Hero';
import { Services } from './components/landing/Services';
import { SolutionsSection } from './components/solutions/SolutionsSection';
import { Contact } from './components/landing/Contact';
import { CaseStudyGrid } from './components/case-studies/CaseStudyGrid';

export const App = () => (
  <ChakraProvider theme={theme}>
    <Box>
      <Navbar />
      <Hero />
      <Services />
      <SolutionsSection />
      <CaseStudyGrid />
      <Contact />
      <CompanyInfo />
      <Footer />
    </Box>
  </ChakraProvider>
);
